import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { HumanizeResponse } from '../types'

interface EditorState {
  // Input state
  inputText: string
  setInputText: (text: string) => void
  
  // Output state
  outputText: string
  setOutputText: (text: string) => void
  
  // Style state
  selectedStyle: string
  setSelectedStyle: (style: string) => void
  
  // Loading state
  isProcessing: boolean
  setIsProcessing: (processing: boolean) => void
  
  // Error state
  error: string | null
  setError: (error: string | null) => void
  
  // Result state
  lastResult: HumanizeResponse | null
  setLastResult: (result: HumanizeResponse | null) => void
  
  // Options
  preserveFormatting: boolean
  setPreserveFormatting: (preserve: boolean) => void
  creativityLevel: number
  setCreativityLevel: (level: number) => void
  
  // Actions
  reset: () => void
  clearOutput: () => void
}

const initialState = {
  inputText: '',
  outputText: '',
  selectedStyle: 'casual',
  isProcessing: false,
  error: null,
  lastResult: null,
  preserveFormatting: true,
  creativityLevel: 50,
}

export const useEditorStore = create<EditorState>()(
  persist(
    (set) => ({
      ...initialState,
      
      setInputText: (text) => set({ inputText: text }),
      setOutputText: (text) => set({ outputText: text }),
      setSelectedStyle: (style) => set({ selectedStyle: style }),
      setIsProcessing: (processing) => set({ isProcessing: processing }),
      setError: (error) => set({ error }),
      setLastResult: (result) => set({ lastResult: result }),
      setPreserveFormatting: (preserve) => set({ preserveFormatting: preserve }),
      setCreativityLevel: (level) => set({ creativityLevel: level }),
      
      reset: () => set(initialState),
      clearOutput: () => set({ outputText: '', lastResult: null, error: null }),
    }),
    {
      name: 'editor-storage',
      partialize: (state) => ({
        selectedStyle: state.selectedStyle,
        preserveFormatting: state.preserveFormatting,
        creativityLevel: state.creativityLevel,
      }),
    }
  )
)
